import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    code: '', 
    nosearchData: null,
    show_section: '',
    show_select_idx: 0,
    show_device: null,
    project_code: ''
  },
  getters: {
    // 计算属性
    code: state => {
      return state.code
    },
    nosearchData: state => {
      return state.nosearchData
    },
    show_section: state => {
      return state.show_section
    },
    show_select_idx: state => {
      return state.show_select_idx
    },
    show_device: state => {
      return state.show_device
    },
    project_code: state => {
      return state.project_code
    },
  },
  mutations: {
    SET_NOSEARCH_DEVICE_DATA(state, payload) {
      state.nosearchData = payload.nosearchData
      state.code = payload.code
      state.project_code = payload.project_code
    },
    SET_SHOW_DEVICE_DATA(state, payload) {
      state.show_section = payload.show_section
      state.show_select_idx = payload.show_select_idx
      state.show_device = payload.show_device
    },
  },
  actions: {
    // 可包含异步操作
    setDeviceData({ commit }, payload) {
      commit('SET_NOSEARCH_DEVICE_DATA', payload)
    },
    setShowDeviceData({ commit }, payload) {
      commit('SET_SHOW_DEVICE_DATA', payload)
    },
  },
  modules: {
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage, // 使用 sessionStorage
      paths: ['code', 'nosearchData', 'show_section', 'show_select_idx', 'show_device', 'project_code'] // 只持久化 device 模块
    })
  ]
})
